<template>

  <div class="hello">
    <main class="ps-page--my-account">
      <div class="ps-breadcrumb">
        <div class="container">
          <ul class="breadcrumb">
            <li v-if="isEnglish()==true"><a href="/#/private">Home</a></li>
            <li v-if="isEnglish()==false"><a href="/#/private">Acceuil</a></li>
            <li v-if="isEnglish()==true" >User Information</li>
            <li v-if="isEnglish()==false" >Informations de l'utilisateur</li>
          </ul>
        </div>
      </div>
      <section class="ps-section--account">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
              <div class="ps-section__left">
                <aside class="ps-widget--account-dashboard">
                  <div class="ps-widget__header"><img src="../assets/img/users/3.jpg" alt="">
                    <figure>
                      <figcaption>Hello</figcaption>
                      <p><a href="#">{{user_email}}</a></p>
                    </figure>
                  </div>
                       <side-menu :lang="lang" :priv_state="priv_state"></side-menu>
                </aside>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="ps-section__right">
                <section class="ps-items-listing">

                  <div class="ps-section__content">
                    <div class="table-responsive">
                      <div v-if="granted" class="alert alert-success" role="alert">
                        {{msg}}
                      </div>


                      <div v-if="sent" class="loading">
                        <div class="spinner-border" role="status">
                        </div>
                        <span class="visually-hidden">Loading...</span>
                      </div>

                      <table class="table ps-table" id="myTable">
                        <thead>
                        <tr>
                          <th>ID</th>
                          <th>Email</th>
                          <th v-if="isEnglish()==true" >Company name</th>
                          <th v-if="isEnglish()==false" >Nom Compagnie</th>
                          <th>Role</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in users" :key="item.email">
                          <td>{{item.id}}</td>
                          <td>{{item.email}}</td>
                          <td>{{item.company_name}}</td>



                          <td>{{item.role_id}}</td>
                          <td >
                            <div v-if="can_display(item)" class="dropdown"><a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="icon-ellipsis"></i></a>
                              <div v-if="isEnglish()==true" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                
                                <a class="dropdown-item"  v-on:click="greet(item)" data-toggle="modal" data-target="#roleModal" href="#">Grant role</a>
                                <a class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#roleModal" href="#">Activate</a>
                                  <a v-if="caller_role=='Super' && item.role_id!='Super'" class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#loginasModal" href="#">Login as</a>
                                <a  class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#divisionsModal" href="#">Divisions</a>
                                <a class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#deleteModal" href="#">Delete</a>
                              </div>

                              <div v-if="isEnglish()==false" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              
                                <a class="dropdown-item"  v-on:click="greet(item)" data-toggle="modal" data-target="#roleModal" href="#">Attribuer role</a>
                                <a class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#roleModal" href="#">Activer </a>
                                  <a v-if="caller_role=='Super' && item.role_id!='Super'" class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#loginasModal" href="#">Se connecter</a>
                                <a  class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#divisionsModal" href="#">Divisions</a>
                                <a class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#deleteModal" href="#">Supprimer</a>
                              </div>
                            </div>
                          </td>
                        </tr>



                        </tbody>
                      </table>
                    </div>
                  </div>

                </section>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="modal fade" id="roleModal" tabindex="-1" role="dialog" aria-labelledby="roleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="isEnglish()==true" class="modal-title" id="roleModalLabel">Are you sure you want to change this user's role?</h5>
              <h5 v-if="isEnglish()==false" class="modal-title" id="roleModalLabel">Etes vous sure de vouloir changer le role de cet utilisateur?</h5>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="row">
                  <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div>

                </div>

                <div class="row">
                  <div class="col"> <div class="form-group">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Name</label>
                     <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Nom</label>
                    <input type="text" v-model="user.name" class="form-control" disabled>
                  </div> </div>
                </div>

                <div class="row">
                  <div class="col">  <div class="form-group">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Company</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Compagnie</label>
                    <input type="text" v-model="user.company_name" class="form-control" disabled>
                  </div></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select Role</label>
                      <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir le Role</label>
                      <select class="form-control" v-model="user.role_id" id="exampleFormControlSelect1">
                        <option value="Basic">Basic</option>
                        <option value="Admin"> Admin</option>
                      </select>
                    </div>
                  </div>

                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button v-if="isEnglish()==true" type="button" class="btn btn-primary" v-on:click="grant_role()">Confirm</button>
               <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button>
              <button v-if="isEnglish()==false" type="button" class="btn btn-primary" v-on:click="grant_role()">Confirmer</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="isEnglish()==true" class="modal-title" id="deleteModalLabel">Are you sure you want to delete {{user.name}} ?</h5>
              <h5 v-if="isEnglish()==false" class="modal-title" id="deleteModalLabel">Etes vous sure de vouloir supprimer {{user.name}} ?</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>

                <div class="row">
                  <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div>
                </div>

                <div class="row">
                  <div class="col"> <div class="form-group">
                    <label for="exampleFormControlSelect1">Email</label>
                    <input type="text" v-model="user.email" class="form-control" disabled>
                  </div> </div>
                </div>

                <div class="row">
                  <div class="col">  <div class="form-group">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Company</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Compagnie</label>
                    <input type="text" v-model="user.company_name" class="form-control" disabled>
                  </div></div>
                </div>

              </form>
            </div>
            <div class="modal-footer">
              <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button v-if="isEnglish()==false" type="button" class="btn btn-primary"  v-on:click="delete_user()">Yes</button>

               <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Non</button>
              <button v-if="isEnglish()==true" type="button" class="btn btn-primary"  v-on:click="delete_user()">Oui</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="loginasModal" tabindex="-1" role="dialog" aria-labelledby="loginasModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="isEnglish()==true" class="modal-title" id="loginasModalLabel">Are you sure you want to login as {{user.email}} ?</h5>
              <h5 v-if="isEnglish()==false" class="modal-title" id="loginasModalLabel">Etes vous sure de vouloir vous connecter en tant que  {{user.email}} ?</h5>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>

                <div class="row">
                  <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div>
                </div>

                <div class="row">
                  <div class="col"> <div class="form-group">
                    <label for="exampleFormControlSelect1">Email</label>
                    <input type="text" v-model="user.email" class="form-control" disabled>
                  </div> </div>
                </div>

                <div class="row">
                  <div class="col">  <div class="form-group">
                    <label v-if="isEnglish()==true"  for="exampleFormControlSelect1">Company</label>
                    <label v-if="isEnglish()==false"  for="exampleFormControlSelect1">Compagnie</label>
                    <input type="text" v-model="user.company_name" class="form-control" disabled>
                  </div></div>
                </div>

              </form>
            </div>
            <div class="modal-footer">
              <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button v-if="isEnglish()==true" type="button" class="btn btn-primary"  v-on:click="make_admin_login_as()">Yes</button>

              <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Non</button>
              <button v-if="isEnglish()==false" type="button" class="btn btn-primary"  v-on:click="make_admin_login_as()">Oui</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="inviteModal" tabindex="-1" role="dialog" aria-labelledby="inviteModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="isEnglish()==true" class="modal-title" id="inviteModalLabel">Send invite to a new user for registration</h5>
              <h5 v-if="isEnglish()==false" class="modal-title" id="inviteModalLabel">Envoyer une invitation pour inscription</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>

                <div class="row form-group">
                  <div class="col">
                    <div  v-if="failed" class="alert alert-danger" role="alert">
                      {{ msg }}
                    </div>
                    <label v-if="isEnglish()==true">Email of your user</label>
                    <label v-if="isEnglish()==false">Email de l'utilisateur</label>
                    <input type="text" v-model="invitee.email" class="form-control" placeholder="Email here" required>
                  </div>
                </div>

                <div v-if="isSuper" class="row form-group">
                  <div class="col">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select the Company</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir la compagnie</label>
                    <select class="form-control" v-model="invitee.no_company"  required>
                      <option  v-for="company in companies" :key="company.no_company" v-bind:value="company.no_company">  ({{company.no_company}}) {{company.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select a Role</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir un Role</label>
                    <select class="form-control" v-model="invitee.role" id="exampleFormControlSelect1">
                      <option value="Basic">Basic</option>
                      <option value="Admin"> Admin</option>
                    </select>
                  </div>
                </div>

              </form>
            </div>
            <div class="modal-footer">
              <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button v-if="isEnglish()==true" type="button" class="btn btn-primary" v-on:click="send_invite()">Send invite</button>

              <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
              <button v-if="isEnglish()==false" type="button" class="btn btn-primary" v-on:click="send_invite()">Envoyer invitation</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="divisionsModal" tabindex="-1" role="dialog" aria-labelledby="divisionsModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="isEnglish()==true" class="modal-title" id="divisionsModalLabel">Assign divisions to user</h5>
              <h5 v-if="isEnglish()==false" class="modal-title" id="divisionsModalLabel">Attribuer des divisions à l'utilisateur</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>

                <div class="row form-group">
                  <div class="col">
                    <div  v-if="failed" class="alert alert-danger" role="alert">
                      {{ msg }}
                    </div>
                    <label v-if="isEnglish()==true" >Email of your user</label>
                    <label v-if="isEnglish()==false" >Email de l'utilisateur</label>
                    <input type="text" v-model="user.email" class="form-control" placeholder="Email here" disabled>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select divisions</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir les divisions</label>
                    <v-select taggable multiple v-model="selected" :options="options" :close-on-select="false"/>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button v-if="isEnglish()==true" type="button" id="assign_divs" class="btn btn-primary" v-on:click="assign_divisions()">Assign</button>

             <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
              <button v-if="isEnglish()==false" type="button" id="assign_divs" class="btn btn-primary" v-on:click="assign_divisions()">Attribuer</button>
            </div>
          </div>
        </div>
      </div>

    </main>
  </div>

</template>

<script>
  import DataService from "@/services/DataService";
  import Vue from 'vue'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';
  import SideMenu from './SideMenu.vue';


  Vue.component('v-select', vSelect)

  export default {
    name: 'Private',
    components: {
    'side-menu': SideMenu
  },
    props: ['search_on','search_obj','language'],
    data () {
      return {
        priv_state:"active",
        msg: '',
        token :localStorage.getItem('token'),
        failed:false,
        user_email: localStorage.getItem('email'),
        granted: false,
        isSuper: false,
        no_company:"",
        sent: false,
        lang : this.language,
        arrived:false,
        caller_role:localStorage.getItem('caller_role'),
        users:[],
        companies:[],
        options:[],
        selected:[],
        invitee:{email:"",no_company:"",company_name:"",role:""},
        user:{ no_company:"",email:"",role_id:"",name:"",company_name:""},
        languages :[{id:1,language:"English", href:"./assets/img/flag/en.png"},{id:2,language:"Français", href:"./assets/img/flag/fr.png"}],





      }
    },
    methods: {
      greet: function (item) {
        this.user.email = item.email;
        this.user.name  = item.name;
        this.user.role_id = item.role_id;
        this.user.no_company = item.no_company;
        console.log(item);
        console.log(localStorage.getItem('token'));
        this.failed = false;

        var dataa={email:item.email};
        this.get_company_name(item.no_company);
        this.users_divisions(dataa,localStorage.getItem('token'));


      },



      login_as(){

       console.log("trying to login as ....");
      },

      assign_divisions(){

        console.log("Printing options :");

        console.log(this.options);

        console.log("Printing selected :");

        console.log(this.selected);
        this.granted = false;
        this.sent = true;
        this.failed = false;
        var dataa={email: this.user.email ,divisions:this.selected};
        var utoken = localStorage.getItem('token');
        DataService.assign_divisions(dataa,utoken)
          .then(response => {
            $('#divisionsModal').modal('hide');
            console.log(response.data);
            this.sent = false;
            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.granted = true;
          })
          .catch(e => {
            console.log(e.response);

            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }
            this.sent = false;
            this.failed = true;
            //this.message = error.response.data.errors[0];
            //console.log(error.response.data.errors);
          });

      },

      users_list(token){

        var dataa = {};

        DataService.fetch_users_list(dataa,token)
          .then(response => {

            console.log(response.data);
            //this.message = response.data.message;


            this.users = response.data.users;
            setTimeout(() => $('#myTable').DataTable(), 1000);

            this.arrived = true;


            this.companies = response.data.companies;
            this.isSuper = response.data.super;
            this.caller_role = response.data.response.data;
            if(response.data.super===false){
              this.no_company = response.data.no_company;
              this.invitee.no_company = response.data.no_company;
            }

          }).catch(e => {
           if(e.response!=undefined){
          console.log(e.response);
          if(e.response.status == 404){
            this.msg = "Route nod found";
           }else if(e.response.status == 401){
             this.$router.push('/login');
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg =  this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }

          this.failed = true;
           }
        });
      },


      can_display(item){

        if(this.caller_role==item.role_id){

           return true

        }else if(this.caller_role=="Super" && item.role_id=="Admin"){

          return true;

        }else if(this.caller_role=="Admin" && item.role_id=="Super"){

          return false;

        }else if(this.caller_role=="Admin" && item.role_id=="Basic"){

          return true;

        }else if(this.caller_role=="Super" && item.role_id=="Basic"){
            return true;
        }
      },

      isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

      },


      users_divisions(dataa,token){

        this.selected = [];
        this.options = [];

        DataService.user_divisions(dataa,token)
          .then(response => {

            console.log(response);
            //this.message = response.data.message;

            response.data.my_divisions.forEach(element => {
              var mydivis = {no_division:element.no_division,label:element.label};
              this.selected.push(mydivis);
            });

            response.data.divisions.forEach(element => {
              var divis = {no_division:element.no_division,label:element.label};
              this.options.push(divis);
            });
            //this.options = response.data.divisions;

          })
          .catch(e => {
            console.log(e.response.status);
            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;
          });
      },


      delete_user(){
        console.log("deleting a user");

        var dataa = {email:this.user.email};

        console.log(dataa);
        var token = this.$parent.token;
        this.failed = false;
        DataService.delete_user(dataa,token)
          .then(response => {

            console.log(response.data);
            $('#deleteModal').modal('hide');
            //this.message = response.data.message;
            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.granted = true;

            this.users_list(this.$parent.token);


          })
          .catch(e => {
            console.log(e.response);

            if(e.response.status == 404){
              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;

          });
      },

      grant_role(){
        this.sent = false;
        var dataa = {email:this.user.email,role:this.user.role_id};

        console.log(dataa);
        var token = this.$parent.token;
        this.sent = true;
        this.failed = false;
        DataService.grant_role(dataa,token)
          .then(response => {

            console.log(response.data);
            $('#roleModal').modal('hide');

            this.sent = false;
            //this.message = response.data.message;
            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.granted = true;

            this.users_list(localStorage.getItem('token'));

          })
          .catch(e => {
            console.log(e.response);
            this.sent = false;
            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg =  this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;
          });
      },


      get_company_name(param){
        var dataa = {no_company:param};
        this.failed = false;
        DataService.get_company_name(dataa)
          .then(response => {

            console.log(response.data);
            this.invitee.company_name = response.data.company_name;
            this.user.company_name = response.data.company_name

          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;
          });
      },


      make_admin_login_as(){

        var dataa = {email:this.user.email};
        var token = localStorage.getItem('token');

        console.log(dataa);

        console.log("PRINTING LOGIN AS");

        DataService.login_as_basic_user(dataa,token)

          .then(response => {

            console.log(response);
            //=============================
           localStorage.setItem('email', this.user.email);
           this.user_email = this.user.email;
           this.$parent.token = response.data.token;
           localStorage.setItem('token', response.data.token);
           this.$parent.company = response.data.company;
           localStorage.setItem('lang', response.data.language);

           if(response.data.language=='en'){

                this.$parent.language = this.languages[0];

           }else if(response.data.language=='fr'){

                this.$parent.language = this.languages[1];
           };

           localStorage.setItem('company', response.data.company);
           localStorage.setItem('caller_role', response.data.caller_role);
           this.caller_role = response.data.caller_role;
           this.$parent.caller_role = response.data.caller_role;
           this.$emit("giveway",true);

                        this.$parent.eventmsg = "You are now connected as "+localStorage.getItem('email');
                        this.$parent.showerrormsg = false;
                        this.$parent.showeventmsg = true;

                        setTimeout(() => this.$parent.showeventmsg = false, 5000);

           if(response.data.caller_role=='Basic'){

                   $('#loginasModal').modal('hide');
                        //this.$router.push('/products');
                  if (this.$router.currentRoute.name !== 'Products') {
                      this.$router.push({ name: 'Products'});
                  }

           }else if(response.data.caller_role=="Admin" || response.data.caller_role=="Super"){

            if (this.$router.currentRoute.name !== 'Private') {
               $('#loginasModal').modal('hide');
                     this.$router.push('/private');
            }else{
              $('#loginasModal').modal('hide');
            }


           }



            //===============================

          }).catch(e => {

              console.log(e.response);

            if(e.response.status == 404){

              this.msg = "Route nod found";

            }else if(e.response.status == 500){

              this.msg = "Sorry , service unavailable at the moment , try again later.";

            }else if(e.response.status == 422){

              this.msg =  this.$parent.translate_error_message(e.response.data.errors,"errors");

            }else {

              this.msg = "Please check your internet.";
            }

            this.failed = true;
          });
      },

      send_invite(){
        this.sent = false;
        var dataa = {email:this.invitee.email,no_company:this.invitee.no_company,role:this.invitee.role};
        this.invitee.email="";this.invitee.no_company="";
        console.log(dataa);
        var token = this.$parent.token;
        this.sent = true;
        this.failed = false;
        DataService.invite_user(dataa,token)
          .then(response => {

            this.sent = false;
            console.log(response.data);
            $('#inviteModal').modal('hide');
            //this.message = response.data.message;
            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.granted = true;
            //this.users_list(this.$parent.token);


          })
          .catch(e => {
            console.log(e.response);
            this.sent = false;
            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;

          });
      }
    },


    watch: {

      search_on:function(){
        console.log("value of search_on is :"+this.search_on);


        if(this.search_on){

          //this.search_user_products(this.search_obj);
           //this.$parent.search_on = false;
           this.$router.push('/products');

        }

        console.log(this.search_obj);
      },

      language:function(){
        this.lang = this.language;
        console.log("language value has changed in private component");
        //this.language = this.lang ;
      }

},

    created(){

      console.log("printimg loggedin value in created :"+this.$parent.loggedin);
      console.log("printimg token value in created :"+this.$parent.token);

      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login');

      }else{

        if(localStorage.getItem('caller_role')=='Basic'){

          this.$router.push('/products');

        }else{

          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
          this.users_list(localStorage.getItem('token'));
        }

      }
    },



    mounted(){
      console.log("printing language changing event in private!");
      console.log(this.lang);
      console.log('==================================');
      console.log("printimg loggedin value in mounted :"+this.$parent.loggedin);
      console.log("printimg token value in mounted :"+this.$parent.token);



    }
  }

</script>








<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /* @import './dassets/apple-touch-icon.png';
  @import './dassets/favicon.png';  */
  @import 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&amp;display=swap';
  @import '../dassets/plugins/font-awesome/css/font-awesome.min.css';
  @import '../dassets/fonts/Linearicons/Font/demo-files/demo.css';
  @import '../dassets/plugins/bootstrap/css/bootstrap.min.css';
  @import '../dassets/plugins/owl-carousel/assets/owl.carousel.css';
  @import '../dassets/plugins/select2/dist/css/select2.min.css';
  @import '../dassets/plugins/summernote/summernote-bs4.min.css';
  @import '../dassets/plugins/apexcharts-bundle/dist/apexcharts.css';
  @import '../dassets/css/style.css';
  @import 'https://cdn.datatables.net/1.10.24/css/jquery.dataTables.min.css';

</style>



// WEBPACK FOOTER //
// src/components/Private.vue